module.exports = __webpack_public_path__ + "img/badge_color_cap-experience.6dea529f.svg";